/* ********************************
 *         Data Handlers
 * ********************************
 */

/* eslint-disable no-unused-vars */
import state from "./index";
import store from "@/store";
import router from "@/router";
import { loadData } from "./data-loader";


/** 
  *  Submit Form Data
  *  
  *   @param  {Object} payload Contain requires inputs for adding data
  *     @property {Object, required} courseOutlineRegistrationInput : {
          academicPeriodId: "", // {String} Get it from filter selection.
          periodCode: "",       // {String} Get it from filter selection.
          degreeId: "",         // {String} Get it from filter selection.
          subjectGroupId: "",   // {String} Get it from filter selection.
          subjectId: "",        // {String} Get it from Course Outline Selection.
          subjectCode: "",      // {String} "----------------------------------"
          subjectName: "",      // {String} "----------------------------------"
          courseOutlineId: "",  // {String} "----------------------------------"
          teacherId: "",        // {String} "----------------------------------"
          teacherCode: "",      // {String} "----------------------------------"
        }
  * 
  */

export const submitForm = async (payload) => {
  const result = await store.dispatch("Examination/addExam", payload);
  return result;
}

// export const addData = async (payload) => {
//   const sample = {
//     courseOutlineRegistrationInput: {
//       academicPeriodId: "",
//       periodCode: "",
//       courseOutlineId: "",
//       degreeId: "",
//       subjectGroupId: "",
//       subjectId: "",
//       subjectCode: "",
//       subjectName: "",
//       teacherId: "",
//       teacherCode: "",
//     }
//   };
//   store.dispatch("Courses/CourseOutlineRegistration/addCourseOutlineRegistration", sample);
// };



// export const handleSelectedListItem = (tr) => {
//   const id = tr.id || null;
//   if (id) {
//     router.push(
//       {
//         name: "vdo-set-topic",
//         params: {
//           vdoSetUnitId: id
//         }
//       }
//     )
//   }
// }


// export const handleEdit = (data) => {
//   if (data) {
//     state.local.form.id = data.id;
//     state.local.form.teacherId = data.teacher.id;
//     state.local.form.vdoSetUnitInput.unitSeq = data.unitSeq;
//     state.local.form.vdoSetUnitInput.code = state.local.vdoSet.code;
//     state.local.form.vdoSetUnitInput.totalVdoLength = data.vdoSet.totalVdoLength;
//     state.local.form.vdoSetUnitInput.status = ""
//     state.local.form.vdoSetUnitInput.remark = ""
//     state.local.editor = { name: "EditVdoSetUnit", mode: "edit", active: true };
//   }
// }


export const handleDeleteListItem = async (tr) => {
  const sure = confirm("Yes or No");
  // const sure = confirm(`ยืนยันการลบ Vdo Set Unit\nวิชา ${tr.subject.nameLocal} (${tr.code})\nสอนโดย ${tr.teacher.firstNameLocal} ${tr.teacher.lastNameLocal} ใช่หรือไม่?`);
  const { id } = tr;
  if (sure) {
    await store.dispatch("Courses/CourseOutlineRegistration/deleteCourseOutlineRegistration", { id });
    alert('Delete Success');
    loadData();
  }
}


// export const submitForm = (formInput) => {
//   if (formInput) {
//     if (state.local.editor.mode === "edit") {
//       _store.dispatch('VdoSet/Units/updateVdoSetUnit', formInput);
//     } else {
//       _store.dispatch('VdoSet/Units/addVdoSetUnit', formInput);
//     }
//   } else {
//     alert("Requires to fill up the form");
//   }
// }
